import React from "react";

const SEVERITY_STYLES = {
  critical: "bg-red-100 text-red-800 border-red-200",
  high: "bg-orange-100 text-orange-800 border-orange-200",
  medium: "bg-yellow-100 text-yellow-800 border-yellow-200",
  low: "bg-blue-100 text-blue-800 border-blue-200",
};

export const SeverityBadge = ({ severity }) => {
  const key = (severity || "").toLowerCase();
  return (
    <span
      className={`px-2 py-0.5 rounded-full text-xs font-semibold border whitespace-nowrap ${
        SEVERITY_STYLES[key] || "bg-gray-100 text-gray-700 border-gray-200"
      }`}
    >
      {severity ? severity.toUpperCase() : "N/A"}
    </span>
  );
};

const STATUS_STYLES = {
  new: "bg-blue-100 text-blue-800 border-blue-200",
  open: "bg-blue-100 text-blue-800 border-blue-200",
  pending: "bg-gray-100 text-gray-700 border-gray-200",
  running: "bg-yellow-100 text-yellow-800 border-yellow-200",
  acknowledged: "bg-purple-100 text-purple-800 border-purple-200",
  investigating: "bg-yellow-100 text-yellow-800 border-yellow-200",
  "in progress": "bg-yellow-100 text-yellow-800 border-yellow-200",
  waiting: "bg-gray-100 text-gray-700 border-gray-200",
  contained: "bg-purple-100 text-purple-800 border-purple-200",
  eradication: "bg-orange-100 text-orange-800 border-orange-200",
  recovery: "bg-cyan-100 text-cyan-800 border-cyan-200",
  resolved: "bg-green-100 text-green-800 border-green-200",
  completed: "bg-green-100 text-green-800 border-green-200",
  closed: "bg-gray-100 text-gray-600 border-gray-200",
  "false positive": "bg-gray-100 text-gray-600 border-gray-200",
  failed: "bg-red-100 text-red-800 border-red-200",
  online: "bg-green-100 text-green-800 border-green-200",
  offline: "bg-gray-100 text-gray-600 border-gray-200",
  warning: "bg-yellow-100 text-yellow-800 border-yellow-200",
  critical: "bg-red-100 text-red-800 border-red-200",
  active: "bg-green-100 text-green-800 border-green-200",
  monitoring: "bg-blue-100 text-blue-800 border-blue-200",
  expired: "bg-gray-100 text-gray-600 border-gray-200",
};

export const StatusBadge = ({ status }) => {
  const key = (status || "").toLowerCase();
  return (
    <span
      className={`px-2 py-0.5 rounded-full text-xs font-semibold border whitespace-nowrap ${
        STATUS_STYLES[key] || "bg-gray-100 text-gray-700 border-gray-200"
      }`}
    >
      {status || "N/A"}
    </span>
  );
};
